/**
 * Global object for cart-related animations using WAAPI
 */
window.DSCartAnimations = {
    /**
     * Fades an element in or out, handling height collapse for 'out' direction
     * @param {HTMLElement} element - The element to animate
     * @param {string} direction - 'in' or 'out'
     * @param {Object} options - Animation options
     * @returns {Promise} - Promise that resolves when animation finishes
     */
    fade(element, direction = 'in', options = {}) {
        if (!element) return Promise.resolve();

        const defaults = {
            duration: 300,
            easing: 'ease-in-out',
            fill: 'forwards'
        };

        const config = { ...defaults, ...options };

        if (direction === 'in') {
            return element.animate([
                { opacity: 0 },
                { opacity: 1 }
            ], config).finished;
        } else if (direction === 'out') {
            // Get current height to animate from
            const height = element.offsetHeight;
            const style = window.getComputedStyle(element);
            const marginTop = parseFloat(style.marginTop);
            const marginBottom = parseFloat(style.marginBottom);
            const paddingTop = parseFloat(style.paddingTop);
            const paddingBottom = parseFloat(style.paddingBottom);

            return element.animate([
                {
                    opacity: 1,
                    transform: 'scale(1)',
                    height: `${height}px`,
                    marginTop: `${marginTop}px`,
                    marginBottom: `${marginBottom}px`,
                    paddingTop: `${paddingTop}px`,
                    paddingBottom: `${paddingBottom}px`,
                    overflow: 'hidden'
                },
                {
                    opacity: 0,
                    transform: 'scale(0.9)',
                    height: '0px',
                    marginTop: '0px',
                    marginBottom: '0px',
                    paddingTop: '0px',
                    paddingBottom: '0px',
                    overflow: 'hidden'
                }
            ], config).finished;
        }
    },

    /**
     * Animates the progress bar width
     * @param {HTMLElement} element - The progress bar fill element
     * @param {number} progress - The target width percentage (0-100)
     * @returns {Promise} - Promise that resolves when animation finishes
     */
    animateProgressBar(element, progress) {
        if (!element) return Promise.resolve();

        const currentWidth = parseFloat(element.style.width) || 0;

        const animation = element.animate([
            { width: `${currentWidth}%` },
            { width: `${progress}%` }
        ], {
            duration: 600,
            easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
            fill: 'forwards',
        });

        // Update the style property so it persists after animation (though fill: forwards handles visual state)
        element.style.width = `${progress}%`;

        return animation.finished;
    },

    /**
     * Slides in the error message from the left
     * @param {HTMLElement} element - The error container element
     * @returns {Promise} - Promise that resolves when animation finishes
     */
    slideInError(element) {
        if (!element) return Promise.resolve();

        return element.animate([
            { transform: 'translateX(-10px)', opacity: 0 },
            { transform: 'translateX(0)', opacity: 1 }
        ], {
            duration: 300,
            easing: 'ease-out',
            fill: 'forwards'
        }).finished;
    }
};

// Backwards compatibility for existing calls if any remain during transition
window.dsFadeAnimation = window.DSCartAnimations.fade;